module.exports = __webpack_public_path__ + "static/media/3DPPA36.49eecacc.jpg";